module.exports = __webpack_public_path__ + "themify.2c454669bdf3aebf32a1.eot";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/themify-icons/fonts/themify.eot
// module id = ../../../../../src/scss/icons/themify-icons/fonts/themify.eot
// module chunks = styles